import { ChangeEvent, FC, MouseEvent, useState } from 'react'
import { uploadFile } from '../../services/image/imageServices'
import styles from './styles.module.css'

interface FileUploaderProps {
  value?: string
  onUploaded: (url: string) => void
  onDeleted?: (url: string) => void
  isView: boolean
  path: string
}

export const FileUploader: FC<FileUploaderProps> = ({
  value,
  onUploaded,
  onDeleted,
  isView,
  path
}) => {
  const [isUploading, setIsUploading] = useState(false)
  const [uploadedImage, setUploadedImage] = useState<string | null>(
    value || null
  )

  const handleUpload = async (selectedFile: File) => {
    const file = selectedFile

    const maxSize = 5 * 1024 * 1024

    const validImageTypes = [
      'image/jpeg',
      'image/png',
      'image/gif',
      'image/webp'
    ]

    if (!validImageTypes.includes(file.type)) {
      alert('Only image files are allowed (jpeg, png, gif, webp).')
      return
    }

    if (file.size > maxSize) {
      alert('File size exceeds the 5 MB limit.')
      return
    }

    setIsUploading(true)
    const url = await uploadFile(selectedFile, path)

    setUploadedImage(url)
    onUploaded(url)
    setIsUploading(false)
  }

  const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    const selectedFile = e.target.files?.[0] || null
    if (selectedFile) {
      handleUpload(selectedFile)
    }
  }

  const handleDelete = async (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()
    if (!uploadedImage) return

    // await deleteFile(uploadedImage)
    if (onDeleted) onDeleted(uploadedImage)
    setUploadedImage(null)
  }

  return (
    <div className={styles.fileUploaderContainer}>
      {uploadedImage ? (
        <div className={styles.uploadedImageWrapper}>
          <img
            src={uploadedImage}
            alt="Uploaded preview"
            className={styles.uploadedImage}
          />
          {!isView && (
            <button
              type="button"
              onClick={handleDelete}
              className={styles.deleteButton}
            >
              ×
            </button>
          )}
        </div>
      ) : (
        !isView && (
          <input
            type="file"
            onChange={handleFileChange}
            disabled={isUploading}
            className={styles.fileInput}
            accept="image/*"
          />
        )
      )}
    </div>
  )
}
